<template>
  <div>
    <div class="contract">
      <Header :groupService="dataContract.groupService"></Header>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">--- o0o ---</p>
      <p class="txt-tranf txt-center fonsize-20 magb20">
        <b>HỢP ĐỒNG CUNG CẤP<br />LOA THÔNG BÁO BIẾN ĐỘNG TÀI KHOẢN</b>
      </p>
      <p class="txt-center">
        Số: <mark>{{ dataContract?.code }}</mark>
      </p>

      <p><b>Căn Cứ</b></p>
      <ul class="form-style2">
        <li>
          Bộ luật Dân sự số 91/2015/QH13 được Quốc hội nước Cộng hòa xã hội chủ nghĩa Việt Nam thông
          qua ngày 24 tháng 11 năm 2015;
        </li>
        <li>
          Luật Thương mại số 36/2005/QH11 do Quốc hội nước Cộng hòa xã hội chủ nghĩa Việt Nam thông
          qua ngày 14 tháng 6 năm 2005;
        </li>
        <li>Nhu cầu và khả năng của hai Bên;</li>
      </ul>

      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataContract.effectiveFromDTO">{{
          dataContract.effectiveFromDTO | formatDate
        }}</mark
        >, chúng tôi gồm:
      </p>

      <p class="fonsize-16 txt-tranf flex">
        <b>BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b>
      </p>
      <p><b>(sau đây được gọi là "BÊN A")</b></p>
      <div class="form form-ext">
        <p>
          Địa chỉ: Tầng 12A, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố
          Hà Nội, Việt Nam.
        </p>
        <p>Điện thoại: 024 36320986</p>
        <p>Mã số thuế: 0106393463</p>
        <p>
          Đại diện: <b>Ông NGUYỄN TIẾN LƯỢNG</b>
          <span class="ml-4">Chức vụ: <b>TỔNG GIÁM ĐỐC</b></span>
        </p>
      </div>

      <p class="fonsize-16 txt-tranf flex mt-3" style="margin-top: 15px">
        <span class="nowrap"><b>BÊN B:</b></span>
        <mark
          ><b>{{ customerInfo.merchantName }}</b></mark
        >
      </p>
      <p><b>(sau đây được gọi là "BÊN B")</b></p>
      <div class="form form-ext">
        <p>
          <span>Địa chỉ:</span>
          <mark>{{ customerInfo.address }}</mark>
        </p>
        <p>
          <span>Email:</span>
          <mark>{{ customerInfo.email }}</mark>
        </p>
        <p>
          <span>Điện thoại:</span>
          <mark>{{ customerInfo.mobile }}</mark>
        </p>
        <p>
          <span>Mã số thuế:</span>
          <mark>{{ customerInfo?.businessRegistrationNumber || customerInfo?.passport }}</mark>
        </p>
        <p>
          <span>Đại diện:</span>
          <mark>{{ customerInfo.customerName }}</mark>
          <span class="ml-4"
            >Chức vụ: <mark>{{ customerInfo.position }}</mark></span
          >
        </p>
        <p>
          <span>Giấy ủy quyền số:.....ngày ....../...../.......</span>
        </p>
        <p>
          <span>Số CMND/CCCD:..............................</span>
          <span>Ngày cấp:..............................</span>
          <span>Nơi cấp:..............................</span>
        </p>
      </div>

      <p>
        Sau khi thỏa thuận, hai bên thống nhất ký kết Hợp đồng mua bán (sau đây gọi là "Hợp đồng")
        với các điều kiện và điều khoản sau:
      </p>

      <ol class="form-style1">
        <li>
          <h1>Điều 1: Hàng hóa và Giá trị Hợp đồng</h1>
          <ol>
            <li>Bên A đồng ý bán, Bên B đồng ý mua thiết bị.</li>
            <li>
              Hàng hóa cung cấp được đóng gói, bao bì theo tiêu chuẩn của Bên A; hàng đảm bảo mới
              100%, có xuất xứ rõ ràng, hợp pháp.
            </li>
            <li>Bên A thực hiện việc đào tạo nghiệp vụ lắp đặt, vận hành hệ thống cho Bên B.</li>
            <li>
              Tổng giá trị hợp đồng:
              <div class="table-responsive magt10">
                <table>
                  <thead>
                    <tr class="bg-head">
                      <th>STT</th>
                      <th>TÊN HÀNG HÓA, DỊCH VỤ</th>
                      <th>ĐVT</th>
                      <th>SỐ LƯỢNG</th>
                      <th>ĐƠN GIÁ (VNĐ)</th>
                      <th>SERIAL</th>
                      <th>THÀNH TIỀN (VNĐ)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="txt-center" v-for="(item, index) in onboardQrDevices" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>Thiết bị Ting-box - Model: {{ item.displayName || 'ONBOARD QR' }}</td>
                      <td>Chiếc</td>
                      <td>{{ item.quantity }}</td>
                      <td>{{ item.price | fomatCurrency }}</td>
                      <td>{{ item.serialNumber }}</td>
                      <td>{{ item.totalPrice | fomatCurrency }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p class="magt10">
                Bằng chữ:
                <mark
                  ><b>{{ totalPrice | formatPriceToText }} đồng</b></mark
                >
                (đã bao gồm VAT).
              </p>
            </li>
          </ol>
        </li>
        <li>
          <h1>Điều 2: Thanh toán</h1>
          <ul class="form-style2">
            <li>Đồng tiền thanh toán: Thanh toán bằng đồng Việt Nam.</li>
            <li>Hình thức thanh toán: Bên B thanh toán cho Bên A ngay sau khi nhận hàng.</li>
            <li>
              Thông tin thanh toán:
              <p>Tên tài khoản: <b>Công ty CP Công Nghệ Vi Mô</b></p>
              <p>Số tài khoản: <b>11001010157634</b></p>
              <p>Ngân hàng: <b>Ngân hàng TMCP Hàng Hải Việt Nam - Sở GD - PGD Nam Hà Nội</b></p>
            </li>
            <li>
              Thông tin xuất hoá đơn:
              <p>
                Tên: <mark>{{ customerInfo.merchantName }}</mark>
              </p>
              <p>
                Địa chỉ: <mark>{{ customerInfo.address }}</mark>
              </p>
              <p>
                Mã số thuế:
                <mark>{{
                  customerInfo?.businessRegistrationNumber || customerInfo?.passport
                }}</mark>
              </p>
            </li>
          </ul>
        </li>
        <li>
          <h1>Điều 3: Loại hợp đồng</h1>
          <p>Hợp đồng trọn gói.</p>
        </li>
        <li>
          <h1>Điều 4: Thời gian thực hiện hợp đồng</h1>
          <p>Thời gian thực hiện hợp đồng kể từ khi hợp đồng có hiệu lực.</p>
        </li>
        <li>
          <h1>Điều 5: Địa điểm, thời gian giao hàng và người được chỉ định nhận hàng</h1>
          <p>
            Địa điểm giao hàng: <mark>{{ customerInfo.address }}</mark>
          </p>
          <p>
            Bên A giao hàng cho Bên B: Giao hàng trong vòng 30 ngày kể từ ngày Hai bên ký kết hợp
            đồng.
          </p>
        </li>
        <li>
          <h1>Điều 6: Bảo hành sản phẩm</h1>
          <ol>
            <li>
              Thời gian bắt đầu tính bảo hành là thời điểm thiết bị được kích hoạt trên hệ thống của
              Bên A.
            </li>
            <li>
              Quy trình tiếp nhận phát sinh liên quan lỗi hàng hoá và bảo hành:
              <ul class="form-style2">
                <li>
                  Khi có phát sinh lỗi bảo hành liên quan hàng hoá, đầu mối phụ trách Bên B liên lạc
                  với đầu mối phụ trách Bên A.
                </li>
                <li>
                  Bên A sau khi tiếp nhận thông tin sẽ hỗ trợ tư vấn cho Bên B cách giải quyết các
                  vấn đề phát sinh.
                </li>
                <li>
                  Nếu hàng hoá cần được kiểm tra và bảo hành thì thực hiện chính sách bảo hành và
                  đổi trả theo quy định chung của Bên A. Bên A phối hợp với Bên B xử lý vấn đề liên
                  quan hàng hoá trên tinh thần hợp tác đảm bảo quyền lợi khách hàng tốt nhất có thể.
                </li>
              </ul>
            </li>
            <li>
              Chính sách bảo hành:
              <p>
                Thời hạn bảo hành là 12 tháng kể từ ngày thiết bị được kích hoạt trên hệ thống Bên
                A.
              </p>
            </li>
            <li>
              Điều kiện bảo hành:
              <p>
                Dịch vụ bảo hành nêu trên bao gồm cả thiết bị, phụ tùng thay thế và công sửa chữa,
                được thực hiện trên cơ sở các điều kiện sau đây:
              </p>
              <ul class="form-style2">
                <li>
                  Thiết bị, các bộ phận thành phần, các phụ tùng và các linh kiện còn nguyên tem bảo
                  hành của Bên A và được xác nhận là còn nguyên vẹn như khi cung cấp, lắp đặt ban
                  đầu; thiết bị bị lỗi, bị hư hỏng trong điều kiện sử dụng bình thường và không xuất
                  phát từ các thao tác sai, bảo quản không đúng hoặc do lỗi của người sử dụng.
                </li>
                <li>
                  Bên A chỉ có trách nhiệm bảo hành hoặc sửa chữa với những thiết bị do Bên A cung
                  cấp.
                </li>
              </ul>
            </li>
            <li>
              Dịch vụ bảo hành không thực hiện trong các trường hợp sau:
              <ul class="form-style2">
                <li>Thiết bị và các bộ phận đã bị cháy do lỗi của người sử dụng.</li>
                <li>Thiết bị không có tem, không có dấu bảo hành.</li>
                <li>
                  Các thiết bị hư hỏng nghiêm trọng do những sai sót và bất cẩn trong quá trình sử
                  dụng và bảo quản hoặc do những nguyên nhân xuất phát từ một bên thứ ba gây ra.
                </li>
                <li>
                  Hậu quả của việc không chấp hành, tuân thủ các điều kiện lắp đặt hoặc các điều
                  kiện đảm bảo môi trường hoặc các điều kiện, quy chế hoạt động, khai thác thiết bị
                  được nêu trong các tài liệu cung cấp cùng các thiết bị.
                </li>
                <li>
                  Thiết bị được cài đặt, lắp đặt hoặc thay đổi các phụ tùng, phụ kiện, linh kiện
                  liên quan không đúng theo yêu cầu kỹ thuật trong tài liệu cung cấp.
                </li>
                <li>
                  Thiết bị đã bị tô vẽ, sơn, khắc…dẫn đến thay đổi hoặc bị biến dạng hình thức bên
                  ngoài.
                </li>
                <li>
                  Hệ thống cấp điện cho thiết bị được thiết lập, sửa chữa, thay đổi hoặc thay thế
                  không đúng với các điều kiện lắp đặt ban đầu hoặc các điều kiện đảm bảo môi
                  trường, các điều kiện, quy chế hoạt động, khai thác thiết bị được nêu trong tài
                  liệu được cung cấp cùng thiết bị.
                </li>
              </ul>
            </li>
            <li>
              Địa điểm nhận sản phẩm bảo hành:
              <p>
                Tại Hà Nội: Tầng 12A, tòa nhà VTC Online, số 18 Tam Trinh, Phường Tương Mai, TP Hà
                Nội. Điện thoại: 0902 144 933
              </p>
            </li>
          </ol>
        </li>
        <li>
          <h1>Điều 7: Trách nhiệm và quyền hạn của hai bên trong hợp đồng</h1>
          <ol>
            <li>
              Quyền và trách nhiệm của Bên B
              <ul class="form-style2">
                <li>
                  Nhận hàng đúng thời hạn, địa điểm, chủng loại và số lượng, chất lượng đã được quy
                  định tại các điều khoản trong hợp đồng này.
                </li>
                <li>Thanh toán đầy đủ và đúng thời hạn theo quy định tại Điều 2 nêu trên.</li>
                <li>
                  Nhận Hoá đơn tài chính, phối hợp hoàn thiện Biên bản bàn giao hàng hóa, Biên bản
                  thanh lý hợp đồng.
                </li>
                <li>
                  Bên B đảm bảo sử dụng hàng hóa mà Bên A cung cấp vào những hoạt động đúng công
                  dụng, đúng mục đích và không trái với quy định của pháp luật. Bên B phải hoàn toàn
                  chịu trách nhiệm về mặt nội dung bản tin phát không trái với quy định của pháp
                  luật, thuần phong mỹ tục và chịu trách nhiệm trước pháp luật về những hành vi vi
                  phạm của mình; Bên A được miễn trừ mọi trách nhiệm trong các trường hợp này.
                </li>
                <li>Các nghĩa vụ khác theo quy định của pháp luật Việt Nam hiện hành.</li>
              </ul>
            </li>
            <li>
              Quyền và trách nhiệm của Bên A
              <ul class="form-style2">
                <li>
                  Giao hàng đúng thời hạn, địa điểm, chủng loại và số lượng, chất lượng đã được quy
                  định tại các điều khoản trong hợp đồng này cho Bên B.
                </li>
                <li>
                  Cung cấp Hoá đơn tài chính, phối hợp hoàn thiện Biên bản bàn giao hàng hóa, Biên
                  bản thanh lý hợp đồng.
                </li>
                <li>
                  Nhận tiền thanh toán từ Bên B theo thời hạn được quy định tại Điều 2 nêu trên.
                </li>
                <li>
                  Có quyền ngừng giao hàng cho Bên B khi Bên B vi phạm quy định thanh toán tại Điều
                  2 Hợp đồng này. Trong trường hợp này, Bên B có trách nhiệm thanh toán theo thông
                  báo của Bên A. Chỉ khi nào Bên A xác nhận việc hoàn thành nghĩa vụ thanh toán của
                  Bên B thì hợp đồng này mới được tiếp tục thực hiện. Đối với bất kỳ vi phạm nào về
                  nghĩa vụ thanh toán hoặc nhận hàng chậm mà không có lý do chính đáng của Bên B,
                  Bên A đều có quyền đơn phương chấm dứt hợp đồng và yêu cầu Bên B bồi thường thiệt
                  hại.
                </li>
                <li>
                  Bên A có quyền từ chối đổi lại các hàng hóa thuộc các điều kiện miễn trừ bảo hành.
                </li>
                <li>
                  Bên A sẽ không chịu bất cứ phạt vi phạm hợp đồng nào nếu các vi phạm có nguyên
                  nhân từ việc chậm thanh toán từ Bên B.
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>Điều 8: Phạt vi phạm hợp đồng</h1>
          <p>
            Bên vi phạm các điều khoản đã nêu trong hợp đồng phải chịu phạt. Tổng giá trị phạt của
            các lần vi phạm cùng một (01) nội dung công việc không vượt quá 8% phần giá trị vi phạm
            (phần giá trị vi phạm được tính bằng tổng giá trị Hợp đồng). Cụ thể như sau:
          </p>
          <ul class="form-style2">
            <li>
              Trường hợp Bên B thanh toán trễ hơn theo quy định tại điều 2 thì Bên B sẽ phải chịu
              mức phạt tương ứng với 4% phần giá trị vi phạm cho 01 lần vi phạm. Ngoài ra, Bên B còn
              phải thanh toán cho Bên A một khoản tiền lãi chậm trả theo lãi suất 0,04% tổng giá trị
              hợp đồng chậm thanh toán tính trên 01 (một) ngày chậm thanh toán.
            </li>
            <li>
              Nếu Bên A giao hàng chậm hơn theo thỏa thuận của hai Bên thì Bên A sẽ phải chịu phạt
              4% phần giá trị vi phạm cho 01 lần vi phạm.
            </li>
            <li>
              Trong trường hợp Bên B nhận hàng chậm so với thời hạn quy định tại thông báo giao hàng
              thì Bên B sẽ chịu phạt 4% phần giá trị vi phạm cho 01 lần vi phạm và Bên B sẽ thanh
              toán cho Bên A toàn bộ các chi phí lưu kho, bãi; chi phí trông giữ hàng hóa và các chi
              phí hợp lý khác (nếu có).
            </li>
            <li>
              Nếu một bên tự ý huỷ bỏ Hợp đồng mà không có sự thoả thuận bằng văn bản của bên kia
              thì phải chịu phạt 8% phần giá trị vi phạm và bồi thường một khoản tiền tương ứng với
              tổng giá trị Hợp đồng.
            </li>
            <li>
              Một trong hai Bên vi phạm các điều khoản khác được quy định trong Hợp đồng này thì
              phải chịu phạt 8% phần giá trị vi phạm.
            </li>
            <li>
              Bồi thường thiệt hại Hợp đồng xảy ra khi một trong hai Bên không thực hiện hoặc thực
              hiện không đầy đủ các điều khoản quy định trong Hợp đồng mà gây thiệt hại cho Bên kia,
              khi đó Bên bị thiệt hại có quyền yêu cầu Bên vi phạm Hợp đồng bồi thường 1% tổng giá
              trị hợp đồng cho 01 lần vi phạm và tối đa không quá tổng giá trị hợp đồng.
            </li>
          </ul>
        </li>
        <li>
          <h1>Điều 9. Quy định về bảo mật thông tin Hợp đồng</h1>
          <ul class="form-style2">
            <li>
              Các Bên có trách nhiệm giữ kín tất cả những thông tin liên quan tới Hợp đồng và Phụ
              lục Hợp đồng mà mình nhận được từ phía Bên kia trong suốt thời hạn của Hợp đồng.
            </li>
            <li>
              Không Bên nào được tiết lộ cho bất cứ Bên thứ ba nào bất kỳ thông tin nói trên trừ
              trường hợp được chấp thuận bằng văn bản của Bên kia hoặc theo yêu cầu của cơ quan quản
              lý Nhà nước có thẩm quyền.
            </li>
            <li>
              Mỗi Bên phải tiến hành mọi biện pháp cần thiết để đảm bảo rằng không một nhân viên nào
              hay bất cứ ai thuộc sự quản lý của mình vi phạm điều khoản này.
            </li>
            <li>
              Điều khoản này vẫn còn hiệu lực ngay cả khi Hợp đồng này hết hiệu lực và hai Bên không
              còn hợp tác.
            </li>
          </ul>
        </li>
        <li>
          <h1>Điều 10: Chấm dứt hợp đồng</h1>
          <p>Hợp đồng chấm dứt trong các trường hợp sau:</p>
          <ul class="form-style2">
            <li>Quyền và nghĩa vụ của các Bên trong Hợp đồng này đã hoàn thành;</li>
            <li>Do hai bên thỏa thuận chấm dứt Hợp đồng bằng văn bản;</li>
            <li>
              Các trường hợp bất khả kháng theo quy định của pháp luật Việt Nam (Sự kiện bất khả
              kháng là sự kiện nằm ngoài tầm kiểm soát của các bên, xảy ra một cách khách quan không
              thể lường trước được và mặc dù Bên gặp phải sự kiện bất khả kháng đã áp dụng mọi biện
              pháp cần thiết và khả năng cho phép nhưng vẫn không thể khắc phục được, bao gồm, nhưng
              không giới hạn những sự kiện sau: hoả hoạn, lũ lụt, động đất, chiến tranh, khủng bố,
              dịch bệnh, quyết định của cơ quan có thẩm quyền, hệ thống Internet và trung tâm dữ
              liệu (hosting) bị gián đoạn do yếu tố hạ tầng đường truyền bị hư hỏng) dẫn đến việc
              một trong các bên không có khả năng tiếp tục thực hiện Hợp đồng này thì phải báo cho
              bên kia biết bằng văn bản trong vòng 07 (Bảy) ngày làm việc kể từ ngày phát sinh vụ
              việc; nếu một trong hai bên không thể tiếp tục thực hiện Hợp đồng do nguyên nhân bất
              khả kháng không bị xem là vi phạm hợp đồng.
            </li>
            <li>
              Nếu một trong hai bên vi phạm các quy định trong hợp đồng, Bên vi phạm phải khắc phục
              các thiệt hại (nếu có), sửa chữa các vi phạm chậm nhất trong vòng 30 ngày làm việc kể
              từ ngày nhận thông báo yêu cầu của phía bên bị vi phạm. Nếu quá thời gian khắc phục
              nêu trên mà các vi phạm vẫn chưa được khắc phục, bên bị vi phạm có quyền đơn phương
              chấm dứt hợp đồng.
            </li>
            <li>
              Thanh lý Hợp đồng: Khi hợp đồng bị chấm dứt trừ trường hợp đơn phương chấm dứt hợp
              đồng, các Bên tiến hành thanh lý hợp đồng. Việc thanh lý hợp đồng phải được lập thành
              văn bản, trong đó xác định rõ mức độ thực hiện hợp đồng của mỗi Bên. Sau khi thanh lý
              hợp đồng, quan hệ hợp đồng giữa các Bên kết thúc nhưng các Bên tiếp tục thực hiện
              quyền và nghĩa vụ của mình theo Biên bản thanh lý.
            </li>
          </ul>
        </li>
        <li>
          <h1>Điều 11: Thông báo và liên hệ</h1>
          <ul class="form-style2">
            <li>
              Mọi thông báo và liên hệ của hai bên với nhau được thực hiện thông qua văn bản, điện
              thoại, fax hoặc email.
            </li>
            <li>
              Trong trường hợp người được ủy quyền giao dịch của Bên B vì lý do nội bộ không còn
              được quyền tiếp tục đại diện trong việc giao dịch với Bên A, Bên B cần có thông báo
              kịp thời, chính thức bằng văn bản/email/fax, gửi người đại diện liên lạc của Bên A
              ngay lập tức và phải được đại diện liên lạc Bên A xác nhận đã nhận được thông báo đó,
              nếu không Bên B phải chịu hoàn toàn trách nhiệm bồi hoàn chi phí thiệt hại cho Bên A
              do việc chậm thông báo trên gây ra.
            </li>
          </ul>
        </li>
        <li>
          <h1>Điều 12: Điều khoản chung</h1>
          <ul class="form-style2">
            <li>
              Hợp đồng có hiệu lực kể từ ngày ký. Hợp đồng hết hiệu lực sau khi hai bên tiến hành
              thanh lý hợp đồng theo luật định.
            </li>
            <li>
              Hai bên cam kết và bảo đảm rằng các bên đã thực hiện đầy đủ tất cả thủ tục pháp lý và
              các thủ tục nội bộ để đảm bảo hiệu lực pháp lý của việc ký kết và thực hiện hợp đồng
              này.
            </li>
            <li>
              Hai bên cam kết thực hiện đúng và đầy đủ những điều khoản được quy định trong hợp đồng
              này.
            </li>
            <li>
              Trong quá trình thực hiện hợp đồng, nếu có mâu thuẫn xảy ra thì hai bên cùng bàn bạc
              tìm biện pháp giải quyết trên tinh thần hòa giải, thiện chí và hợp tác. Trường hợp hai
              bên không tự giải quyết được các tranh chấp phát sinh thì vụ việc sẽ được đưa ra giải
              quyết tại Tòa án nhân dân có thẩm quyền tại, toàn bộ chi phí xét xử do Bên thua chịu.
            </li>
            <li>
              Hợp đồng này được lập thành 02 (Hai) bản, mỗi bên giữ 01 (Một) bản có giá trị pháp lý
              như nhau.
            </li>
          </ul>
        </li>
      </ol>
      <Footer :dataContract="dataContract" :dataAppendix="dataAppendix" :isAppendix="true"></Footer>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return (
          this.appendix ?? this.dataContract.lstAppendixDevices.find(e => e.isCreatedWithContract)
        )
      },
      onboardQrDevices() {
        if (this.dataAppendix?.appendixDevice?.deviceInfos) {
          return this.dataAppendix.appendixDevice.deviceInfos || []
          // return this.dataAppendix.appendixDevice.deviceInfos.filter(d => d.name === 'ONBOARD_QR')
        }
        return []
      },
      totalPrice() {
        return this.onboardQrDevices.reduce((total, item) => total + (item.totalPrice || 0), 0)
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
